module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tochd"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknow"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Credits"
    }
  }, [_vm._v("Image Credits")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Capital"
    }
  }, [_vm._v("A Capital Question")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter1"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter One")]), _vm._v(" The Roots of the Salvation Army")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter Two")]), _vm._v(" Early Days")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter Three")]), _vm._v(" While Women Weep")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter Four")]), _vm._v(" Purgatory before the Grave")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter Five")]), _vm._v(" War and Disaster")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter Six")]), _vm._v(" An International Organisation")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter Seven")]), _vm._v(" The Salvation Army and the Media")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter Eight")]), _vm._v(" Unresolved Issues")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Appendix1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Appendix A")]), _vm._v(" Forty years of service: Salvation Army response to major worldwide crises")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Appendix2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Appendix B")]), _vm._v(" Where the Salvation Army works today with dates of beginnings")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_References",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0